var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"twoview"},[_c('Sidebar2',{attrs:{"sidebar-list":_vm.listsData}}),_c('div',{staticClass:"twoviewMain"},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('router-view')],1)],1),_c('Foot')],1)}
var staticRenderFns = []

export { render, staticRenderFns }